import { render } from "./LegacyNoticeComponent.vue?vue&type=template&id=751f5022&scoped=true"
import script from "./LegacyNoticeComponent.vue?vue&type=script&lang=js"
export * from "./LegacyNoticeComponent.vue?vue&type=script&lang=js"

import "./LegacyNoticeComponent.vue?vue&type=style&index=0&id=751f5022&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751f5022"]])

export default __exports__